import React from 'react';

interface CTASectionProps {
  onOpenSimulation: () => void;
}

export const CTASection: React.FC<CTASectionProps> = ({ onOpenSimulation }) => {
  return (
    <section className="py-20 bg-gradient-to-r from-teal-900 to-sky-900">
      <div className="container mx-auto px-6 text-center">
        <h2 className="text-4xl font-bold mb-6 text-white">Descubra Quanto Custará Seu Projeto</h2>
        <p className="text-xl text-gray-400 mb-8">
            Processo super fácil e gratuito. Conte-nos sobre seu projeto e receba um orçamento personalizado em até 24h.
          </p>
        <div className="overflow-hidden">
          <button
            onClick={onOpenSimulation}
            className="px-8 py-4 text-lg bg-white text-slate-900 font-bold rounded-full shadow-lg transition-transform duration-300 transform hover:scale-105"
            style={{ transformOrigin: 'center center' }}
          >
            Solicitar Orçamento Gratuito
          </button>
        </div>
      </div>
    </section>
  );
};